import { i18nPlugin } from '../../plugins/a.i18n'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(i18nPlugin)
